import script from "./StaffCheckBoxList.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffCheckBoxList.vue?vue&type=script&setup=true&lang=js"

import "./StaffCheckBoxList.vue?vue&type=style&index=0&id=79b52e0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b52e0e"]])

export default __exports__